const mutations = {
  ["DeliveryDirectMailFlagActions"](state, payload) {
    // console.log("pay email", payload);
    state.directMailDeliveryBoxFlag = payload;
    // console.log(88, state.directMailDeliveryBoxFlag);
  },
  ["PrintPublicationTypeBoxFlag"](state, payload) {
    state.printPublicationTypeBoxFlag = payload;
  },
  ["EmailElectronicTypeBoxFlagActions"](state, payload) {
    state.emailElectronicTypeBoxFlag = payload;
  },
  ["SocialNetworkNameBoxFlagActions"](state, payload) {
    state.socialNetworkNameBoxFlag = payload;
  },
  ["lastSearchTriggerredMut"](state, payload) {
    state.lastSearchTriggerred = payload;
  },
  ["BankingOptionBoxFlagActions"](state, payload) {
    state.isBankingOptionOn = payload;
  },
  ["CreditOptionBoxFlagActions"](state, payload) {
    state.isCreditOptionOn = payload;
  },
  ["DashboardDirectMailBoxFlagMut"](state, payload) {
    // console.log("mut pay", payload);
    state.DashboardDirectMailOptionBoxFlagState = payload;
  },
  ["DashboardDirectMailEmailBoxFlagMut"](state, payload) {
    // console.log("mut pay", payload);
    state.DashboardDirectMailemailOptionBoxFlagState = payload;
  },
  ["DashboardBoxFlagMut"](state, payload) {
    // console.log("mut pay", payload);
    state.dashboardFlag = payload;
  },
  ["selectedDataMut"](state, payload) {
    let key = Object.keys(payload);
    let value = Object.values(payload);
    // console.log(key[0], " key");
    // console.log(value[0], " vv");
    if (key[0] === "mChannelID") {
      if (state.selectedData[key] !== undefined) {
        value[0].forEach((i) => {
          if (state.selectedData[key].length > 0) {
            let totalids = [];
            state.selectedData[key].forEach((t) => {
              totalids.push(t.mChannelID);
            });
            let flag = totalids.includes(i.mChannelID);
            if (!flag) {
              state.selectedData[key].push(i);
            }
          } else {
            state.selectedData[key].push(i);
          }
        });
      } else {
        state.selectedData[key[0]] = [];
      }
    }

    //sector
    if (key[0] === "sectorID") {
      if (state.selectedData[key] !== undefined) {
        value[0].forEach((i) => {
          if (state.selectedData[key].length > 0) {
            let totalids = [];
            state.selectedData[key].forEach((t) => {
              totalids.push(t.sectorID);
            });
            let flag = totalids.includes(i.sectorID);
            if (!flag) {
              state.selectedData[key].push(i);
            }
          } else {
            state.selectedData[key].push(i);
          }
        });
      } else {
        state.selectedData[key[0]] = [];
      }
    }

    // audience
    if (key[0] === "mPanelID") {
      if (state.selectedData[key] !== undefined) {
        value[0].forEach((i) => {
          if (state.selectedData[key].length > 0) {
            let totalids = [];
            state.selectedData[key].forEach((t) => {
              totalids.push(t.mPanelID);
            });
            let flag = totalids.includes(i.mPanelID);
            if (!flag) {
              state.selectedData[key].push(i);
            }
          } else {
            state.selectedData[key].push(i);
          }
        });
      } else {
        state.selectedData[key[0]] = [];
      }
    }
    // console.log(state.selectedData, "state.selectedData");
    // console.log(state.selectedData, "state.selectedData");
  },
  ["additionalSelectedDataMut"](state, payload) {
    if (Object.keys(state.additionalSelectedData).length !== 0) {
      let statekeys = [];
      for (
        let i = 0;
        i < Object.keys(state.additionalSelectedData).length;
        i++
      ) {
        statekeys = Object.keys(state.additionalSelectedData);
      }
      for (
        let i = 0;
        i < Object.keys(state.additionalSelectedData).length;
        i++
      ) {
        let key = Object.keys(payload)[0];
        let value = Object.values(payload)[0];
        // console.log(state.additionalSelectedData, "taa");
        // console.log(key, "keys", value);
        if (key == "electronicID_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].electronic_id !==
                payload[key].electronic_id
              ) {
                state.additionalSelectedData[key].push(...value);
              }
            }
          } else {
            let electroniccopy = {};
            electroniccopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(electroniccopy)
            );
          }
        }
        if (key == "CardNetwork_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].CardTypeID !==
                payload[key].CardTypeID
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let cardcopy = {};
            cardcopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(cardcopy)
            );
          }
        }
        if (key == "camp") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i].id !== payload[key].id) {
                state.additionalSelectedData[key].push(...value);
              }
            }
          } else {
            let cardcopy = {};
            cardcopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(cardcopy)
            );
          }
        }
        if (key == "responseMechID_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].responseMechID !==
                payload[key].responseMechID
              ) {
                state.additionalSelectedData[key].push(...value);
              }
            }
          } else {
            let respcopy = {};
            respcopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(respcopy)
            );
          }
        }
        if (key == "FeeProductType") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].ancillary_id !==
                payload[key].ancillary_id
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let ancpcopy = {};
            ancpcopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(ancpcopy)
            );
          }
        }
        if (key == "state") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].stateID !==
                payload[key].stateID
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let stcopy = {};
            stcopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(stcopy)
            );
          }
        }
        if (key == "age") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].age_pID !==
                payload[key].age_pID
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let agcopy = {};
            agcopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(agcopy)
            );
          }
        }
        if (key == "income_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].incomeID !==
                payload[key].incomeID
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let inccopy = {};
            inccopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(inccopy)
            );
          }
        }
        if (key == "fico_score") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i].id !== payload[key].id) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let ficcopy = {};
            ficcopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(ficcopy)
            );
          }
        }
        if (key == "credit_vision_score") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i].id !== payload[key].id) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let crcopy = {};
            crcopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(crcopy)
            );
          }
        }
        if (key == "Income_Producing_Assets_Segment_Code_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].incomeID !==
                payload[key].incomeID
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let crcopy = {};
            crcopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(crcopy)
            );
          }
        }
        if (key == "vantage_score") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i].id !== payload[key].id) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "ApplicationType_mult") {
          // console.log(value, "value");
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].ApplicationTypeID !==
                payload[key].ApplicationTypeID
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "pubTypeID_mult") {
          // console.log(value, "value");
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].print_typeID !==
                payload[key].print_typeID
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        //mailing
        if (key == "mTypeID") {
          console.log(value, "value");
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].mTypeID !==
                payload[key].mTypeID
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "IntroPricing_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i].id !== payload[key].id) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "postageId") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].postageId !==
                payload[key].postageId
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "businessContent_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i].id !== payload[key].id) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "agentCommunicationID") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i].ID !== payload[key].ID) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "delmethid_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].delmethid !==
                payload[key].delmethid
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "deliveryTypeId") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].deliveryTypeId !==
                payload[key].deliveryTypeId
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "presortedId") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].presortedId !==
                payload[key].presortedId
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "affinityAssociation") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "worksiteVoluntary") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "creditUnion") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "is_incentive") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        //
        if (key == "conventional") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "fha") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "is_hphsa") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "jumbo_ncnfg") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "usda") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "faux_check") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "va") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "prescription") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "is_affinion") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "is_citi") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "correspondent_lending") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "is_prescreen") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "FeeProduct") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "refinance") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i] !== payload[key]) {
                state.additionalSelectedData[key] = value;
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "groupSize") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i].id !== payload[key].id) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "AffinityCategoryID_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].AffinityCategoryID !==
                payload[key].AffinityCategoryID
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "AffinitySubCategoryID_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].AffinityCategoryID !==
                payload[key].AffinityCategoryID
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "offer") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].oo_id !==
                payload[key].oo_id
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "ERateType_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i].id !== payload[key].id) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "EOfferPrice_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].OfferPriceID !==
                payload[key].OfferPriceID
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "DMA_ID_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].code !== payload[key].code
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "ETermLength_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].TermLengthID !==
                payload[key].TermLengthID
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "value_score") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].code !== payload[key].code
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "fa_id_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].fa_id !==
                payload[key].fa_id
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "riders_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].code !==
                payload[key].ridersID
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "IssueTypeID_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].code !==
                payload[key].IssueTypeID
              ) {
                state.additionalSelectedData[key].push(value);
              }
            }
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "RewardsProgramEmphasis_mult") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].RewardTypeID !==
                payload[key].RewardTypeID
              ) {
                // console.log(value, "value");
                state.additionalSelectedData[key].push(value);
              }
            }
            // console.log(statekeys, "stat,", key, "pppp", payload[key]);
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "external_link") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i].id !== payload[key].id) {
                // console.log(value, "value");
                state.additionalSelectedData[key].push(value);
              }
            }
            // console.log(statekeys, "stat,", key, "pppp", payload[key]);
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "socialmedia_adtype") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (state.additionalSelectedData[key][i].id !== payload[key].id) {
                // console.log(value, "value");
                state.additionalSelectedData[key].push(value);
              }
            }
            // console.log(statekeys, "stat,", key, "pppp", payload[key]);
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        if (key == "offerOrigin") {
          if (statekeys.includes(key.toString())) {
            if (state.additionalSelectedData[key][i] !== undefined) {
              if (
                state.additionalSelectedData[key][i].oo_id !==
                payload[key].oo_id
              ) {
                // console.log(value, "value");
                state.additionalSelectedData[key].push(value);
              }
            }
            // console.log(statekeys, "stat,", key, "pppp", payload[key]);
          } else {
            let vancopy = {};
            vancopy = Object.values(payload);
            state.additionalSelectedData[key] = JSON.parse(
              JSON.stringify(vancopy)
            );
          }
        }
        // console.log(state.additionalSelectedData[key], 22);
      }
    } else {
      let key = Object.keys(payload);
      if (key == "electronicID_mult") {
        let electroniccopy = {};
        electroniccopy = Object.values(payload);
        // console.log(JSON.parse(JSON.stringify(innerObj)), "val");
        state.additionalSelectedData[key] = JSON.parse(
          JSON.stringify(electroniccopy)
        );
      }
      if (key == "CardNetwork_mult") {
        let cardcopy = {};
        cardcopy = Object.values(payload);
        // console.log(JSON.parse(JSON.stringify(innerObj)), "val");
        state.additionalSelectedData[key] = JSON.parse(
          JSON.stringify(cardcopy)
        );
      }
      if (key == "responseMechID_mult") {
        let respcopy = {};
        respcopy = Object.values(payload);
        // console.log(JSON.parse(JSON.stringify(innerObj)), "val");
        state.additionalSelectedData[key] = JSON.parse(
          JSON.stringify(respcopy)
        );
      }
      if (key == "FeeProductType") {
        let anccopy = {};
        anccopy = Object.values(payload);
        // console.log(JSON.parse(JSON.stringify(innerObj)), "val");
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(anccopy));
      }
      if (key == "FeeProductType") {
        let stcopy = {};
        stcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(stcopy));
      }
      if (key == "age") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "AffinityCategoryID_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "AffinitySubCategoryID_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "value_score") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "riders_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "IssueTypeID_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "RewardsProgramEmphasis_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "ApplicationType_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "vantage_score") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "offer") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "fico_score") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "income_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "Income_Producing_Assets_Segment_Code_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "state") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "IntroPricing_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "businessContent_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "agentCommunicationID") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "delmethid_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "deliveryTypeId") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "presortedId") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "groupSize") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "ERateType_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "EOfferPrice_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "ETermLength_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "DMA_ID_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "fa_id_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "mTypeID") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "camp") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "external_link") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "socialmedia_adtype") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "offerOrigin") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "pubTypeID_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "affinityAssociation") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "pubTypeID_mult") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "worksiteVoluntary") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "creditUnion") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "is_incentive") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "conventional") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "fha") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "is_hphsa") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "jumbo_ncnfg") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "usda") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "correspondent_lending") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "va") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "prescription") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "is_citi") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "refinance") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "faux_check") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
      if (key == "is_affinion") {
        let agcopy = {};
        agcopy = Object.values(payload);
        state.additionalSelectedData[key] = JSON.parse(JSON.stringify(agcopy));
      }
    }
    // console.log(state.additionalSelectedData, "state.additionalSelectedData");
  },
};
export default mutations;
